module.exports = __webpack_public_path__ + "static/media/pdp_moto_mid-banner-mob.91eaadef.png";